import { useTranslation } from 'react-i18next'

import NavBarLink from './NavBarLink/Index'
import { RouteSatClientsPage } from 'routes'

const NavSatClients = () => {
  const { t } = useTranslation()

  return (
    <NavBarLink name={t('mainHeader.userSatClients')} to={RouteSatClientsPage()} />
  )
}

export default NavSatClients
